import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <section id="home" className="min-h-screen bg-pink-primary flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 bg-yellow-primary rounded-full"></div>
        <div className="absolute top-40 right-32 w-24 h-24 bg-red-primary rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-40 h-40 bg-white rounded-full"></div>
        <div className="absolute bottom-40 right-20 w-20 h-20 bg-yellow-primary rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            className="text-5xl md:text-7xl font-league-spartan font-bold text-white mb-6"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <span className="text-white">Aprende</span>{" "}
            <span className="text-yellow-primary">inglés</span>{" "}
            <span className="text-white">desde</span>{" "}
            <span className="text-yellow-primary">donde estés</span>
          </motion.h1>

          <motion.p
            className="text-xl md:text-2xl text-white mb-8 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Descubre un inglés práctico y comunicativo, con clases dinámicas que van más allá de la gramática. Todo 100% en línea, para que aprendas desde cualquier lugar y en poco tiempo puedas hablar inglés con confianza y sin complicaciones.
          </motion.p>


          <motion.div
            className="mt-12 flex justify-center space-x-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <div className="text-center text-white">
              <img src="/set/2.png" alt="125+ Estudiantes Felices" className="w-24 h-24 mx-auto mb-2" />
              <div className="text-sm">125+ Estudiantes Felices</div>
            </div>
            <div className="text-center text-white">
              <img src="/set/3.png" alt="Clases 100% Online" className="w-24 h-24 mx-auto mb-2" />
              <div className="text-sm">Clases 100% Online</div>
            </div>
            <div className="text-center text-white">
              <img src="/set/4.png" alt="Chat de Soporte Online" className="w-24 h-24 mx-auto mb-2" />
              <div className="text-sm">Chat de Soporte Online</div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;